<template>
    <div class="workspace-dropdown-2-container">
        <div class="dropdown-select" ref="dropdownSelect" :disabled="props.disabled">
            <PzIcon class="icon-prefix" v-if="props.icon" :icon="props.icon" />
            <div class="dropdown-label">{{ props.selectedOption.tag }}</div>
            <PzIcon class="icon-suffix" v-if="options && options.length > 1" :icon="isShown ? (closeIcon||'SolidArrowUp') : (openIcon||'SolidArrowDown')" />
        </div>
        <div ref="dropdownOptions" class="workspace-dropdown-2-container_dropdown-options">
            <div class="dropdown-option" :class="{'option-selected':option.key === props.selectedOption.key}" v-for="option in options" :key="option.key" :value="option.key" @click="onSelect(option)">
                <div class="dropdown-option_label">{{ option.label }}</div>
                <div class="dropdown-option_icon">
                    <PzIcon icon="SolidTick" v-if="option.key === props.selectedOption.key" />
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { Icon, Popper } from 'patsnap-biz';

import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg'
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg'
import '@patsnap-ui/icon/assets/solid/tick.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
import { computed, onMounted, ref } from 'vue';
import _ from 'lodash';

// @ts-ignore
const tippy = Popper.tippy;

const PzIcon = Icon

type IOptionItem = {
    label: string;
    tag: string;
    key: string;
}

const props = defineProps<{
    options: IOptionItem[],
    selectedOption: IOptionItem,
    disabled?: boolean,
    icon?: string,
    openIcon?: string,
    closeIcon?: string,
    sourceIn: 'WORKSPACE' | 'ANALYTICS' | 'EUREKA' | 'VOTE',
}>()

const emits = defineEmits<{
    (event: 'change', option: IOptionItem): void;
}>();

const dropdownSelect = ref(null)
const dropdownOptions = ref(null)
const tippyInstance = ref(null);

const isShown = computed(() => {
    return _.get(tippyInstance.value, 'state.isShown', false)
})

const onSelect = (option) => {
    if (tippyInstance.value) {
        (tippyInstance.value as any).hide();
    }
    emits('change', option)
}

onMounted(() => {
    tippyInstance.value = tippy(dropdownSelect.value, {
        trigger: 'click',
        interactive: true,
        content: dropdownOptions.value,
        allowHTML: true,
        theme: 'light',
        arrow: false,
        appendTo: () => document.body,
        placement: 'bottom-start',
        offset: props.sourceIn === 'ANALYTICS' ? [0, 8] : [0, 0],
    });
})

</script>
<style lang="scss">
.workspace-dropdown-2-container{
    .dropdown-select {
        height: 24px;
        padding: 4px 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        border-radius: 4px;
        background: $status-info-lightest;
        color: $status-info-primary;
        .icon-prefix {
            font-size: 16px;
            margin-right: 4px;
            margin-bottom: 0;
        }
        .icon-suffix {
            font-size: 16px;
            margin-left: 4px;
            margin-bottom: 0;
        }
        &:hover {
            color: $status-info-hover;
        }
    }
    &_dropdown-options {
        .dropdown-option {
            min-width: 280px;
            max-width: 420px;
            font-size: 14px;
            color: $text-primary;
            padding: 4px 8px;
            cursor: pointer;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            &.option-selected {
                color: $brand-hover;
            }
            &:hover {
                background: $bg-hover;
            }
            &_label {
                line-height: 24px;
            }
            &_icon {
                width: 40px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                .patsnap-biz-icon {
                    font-size: 22px;
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>
